import { CustomAxios } from '../../axios/axios';

export const getThread = async ({ guide, threadId }) => {
  const { BusinessID, AssistantID } = guide?.[0] || {};
  const { data } = await CustomAxios.get(`/public/v1/business/${BusinessID}/assistant/${AssistantID}/thread/${threadId}`, {
    headers: { 'Content-Profile': 'brite' },
  });
  return data;
};

export const sendMessage = async ({ guide, threadId, message }) => {
  const { BusinessID, AssistantID } = guide?.[0] || {};
  const { data } = await CustomAxios.post(
    `/public/v1/business/${BusinessID}/thread/${threadId}`,
    {
      message,
      assistant_id: AssistantID,
    },
    { headers: { 'Content-Profile': 'brite' } }
  );
  return data;
};
